// Unified yacht systems & services taxonomy — the SINGLE source of truth on
// the frontend. Mirror of backend/models/taxonomy.py UNIFIED_SYSTEMS.
//
// Used identically by:
//   - Maintenance tasks  (system dropdown — maintenance/constants.js)
//   - Suppliers + Invoices  (lib/supplierCategories.js)
// so a task system always matches the supplier/invoice taxonomy 1:1.

export const UNIFIED_SYSTEMS = [
  // Propulsion & mechanical
  "Engines & Propulsion",
  "Generators",
  "Bow & Stern Thrusters",
  "Stabilizers",
  "Hydraulics",
  "Steering & Rudders",
  // Electrical & electronics
  "Electrical",
  "Batteries & Power",
  "Navigation & Electronics",
  "AV / IT & Communications",
  // Climate, plumbing & water
  "Air Conditioning & Refrigeration",
  "Plumbing & Sanitation",
  "Watermaker",
  "Bilge & Pumps",
  "Fuel & Bunkering",
  // Hull, structure & finish
  "Hull & Underwater",
  "Painting & Coatings",
  "Fiberglass & Composites",
  "Stainless Steel & Welding",
  "Teak & Decking",
  "Rigging & Sails",
  // Deck, interior & tenders
  "Deck & Exterior",
  "Interior & Joinery",
  "Upholstery & Furnishings",
  "Tenders & Toys",
  // Safety & survey
  "Safety & Firefighting",
  "Diving & Underwater Services",
  "Surveyors & Inspection",
  // Operations & services
  "Cleaning & Detailing",
  "Refit & Project Management",
  "Provisioning",
  "Marina & Dockage",
  "Logistics & Transport",
  "Crew Services",
  "Charter & Brokerage",
  "Insurance & Finance",
  "Registration & Legal",
  "General / Other",
];

// Legacy value -> unified name, so old stored rows still display nicely until
// the one-time backend migration rewrites them.
export const LEGACY_SYSTEM_MAP = {
  Engines: "Engines & Propulsion",
  "Bow Thruster": "Bow & Stern Thrusters",
  "Air conditioning": "Air Conditioning & Refrigeration",
  Navigation: "Navigation & Electronics",
  Tender: "Tenders & Toys",
  Stabilizer: "Stabilizers",
  Plumbing: "Plumbing & Sanitation",
  Hull: "Hull & Underwater",
  Interior: "Interior & Joinery",
  Exterior: "Deck & Exterior",
  Teak: "Teak & Decking",
  Safety: "Safety & Firefighting",
  "AV/Entertainment": "AV / IT & Communications",
  Batteries: "Batteries & Power",
  "Bilge pumps": "Bilge & Pumps",
  engine_service: "Engines & Propulsion",
  electrical: "Electrical",
  electronics_av: "Navigation & Electronics",
  painting_refit: "Painting & Coatings",
  carpentry_interior: "Interior & Joinery",
  rigging_sails: "Rigging & Sails",
  hull_underwater: "Hull & Underwater",
  provisions: "Provisioning",
  fuel_bunkering: "Fuel & Bunkering",
  laundry_housekeeping: "Cleaning & Detailing",
  marina_dockage: "Marina & Dockage",
  agent_clearance: "Registration & Legal",
  broker_charter: "Charter & Brokerage",
  insurance_finance: "Insurance & Finance",
  legal_compliance: "Registration & Legal",
  safety_survey: "Safety & Firefighting",
  transport_logistics: "Logistics & Transport",
  other: "General / Other",
  service_provider: "General / Other",
  marina: "Marina & Dockage",
  fuel: "Fuel & Bunkering",
  refit: "Refit & Project Management",
  Engine: "Engines & Propulsion",
  Propulsion: "Engines & Propulsion",
  Deck: "Deck & Exterior",
  HVAC: "Air Conditioning & Refrigeration",
  Admin: "General / Other",
  "Hull / Underwater": "Hull & Underwater",
  "Electronics / AV": "Navigation & Electronics",
  "Painting / Refit": "Painting & Coatings",
};

export function labelForSystem(value) {
  if (!value) return "—";
  if (UNIFIED_SYSTEMS.includes(value)) return value;
  return LEGACY_SYSTEM_MAP[value] || value;
}
